// TODO move to lang-extensions
/* eslint-disable-next-line no-new-func */
const global = Function("return this")();
global.globalThis = global;
